<template>
  <div>
    <!-- <b-breadcrumb style="background-color:#f8f9fa" :items="itemsBreadcrumb"></b-breadcrumb> -->
    <b-row>
      <b-col cols="12">
        <b-overlay
          :show="isLoading"
          rounded="sm"
          opacity="1"
        >
          <b-card
            no-body
            class="shadow-sm pt-0 pl-0 pr-0 m-4 mb-0"
          >
            <b-navbar
              class="background-white"
              toggleable="lg"
            >
              <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
              <b-navbar-brand href="#">
                <strong style="color: #3b3e66">Health And Safety Policies</strong>
              </b-navbar-brand>

              <b-collapse
                id="nav-collapse"
                is-nav
              >
                <b-navbar-nav class="ml-auto">
                  <b-nav-form>
                    <b-button
                      class="mr-2"
                      variant="outline-dark"
                      size="sm"
                      @click="exportDatePolicyData"
                    >
                      Export
                    </b-button>

                    <b-button
                      class="mr-2"
                      variant="outline-dark"
                      size="sm"
                      @click="exportPolicyData"
                    >
                      Export All
                    </b-button>
                    <b-button
                      variant="outline-info"
                      size="sm"
                      class="mr-2"
                      @click="reloadTable"
                    >
                      Reload
                    </b-button>
                    <!-- <b-button
                      variant="outline-info"
                      size="sm"
                      class="mr-2"
                    >
                      Filter
                    </b-button> -->
                    <b-form onSubmit="return false;">
                      <b-input-group size="sm">
                        <b-form-input
                          type="search"
                          @input="onEmpltyFilter($event)"
                          v-model="filter"
                          @keyup.enter="submitSearch"
                          placeholder="Type to Search"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            :disabled="!filter"
                            variant="outline-success"
                            @click="submitSearch"
                          >Search</b-button>
                          <b-button
                            :disabled="!filter"
                            @click="setFIlterClear"
                          >Clear</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form>
                  </b-nav-form>
                </b-navbar-nav>
              </b-collapse>
            </b-navbar>
            <div v-show="!isLoading">
            <b-table
              class="main-table"
              hover
              striped
              sticky-header="calc(100vh - 295px)"
              ref="table"
              id="health-and-safety-policy-data-table"
              :busy.sync="isLoading"
              :fields="staticFields"
              :items="setGovernanceTableData"
              :filter="filterTable ? filter : null"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              selectable
              select-mode="single"
              @row-selected="onSelectRow"
              no-sort-reset
            >
              <template v-slot:table-colgroup="scope">
                <col
                  v-for="field in scope.fields"
                  :key="field.key"
                  :style="field.width ? 'width:' + field.width : ''"
                />
              </template>
              <template v-slot:head(checkbox)>
                <div class="text-center">
                  <b-form-checkbox
                    v-model="selectedEmployee"
                    value="1"
                    unchecked-value="0"
                    @input="selectAllRows($event)"
                  > </b-form-checkbox>
                </div>
              </template>
              <template v-slot:cell(checkbox)="data">
                <div class="text-center">
                  <b-form-checkbox
                    v-model="selectedEmployeeList[data.index]"
                    value="1"
                    unchecked-value="0"
                    @input="selectMultipleRows($event, data)"
                  > </b-form-checkbox>
                </div>
              </template>
              <template v-slot:cell(first_name)="data">
                <p
                  class="link-text"
                  @click="OpenProfilePage('/employee-profile/' + data.item.id)"
                >
                  {{ data.item.first_name }}
                </p>
              </template>
              <template v-slot:cell(last_name)="data">
                <p
                  class="link-text"
                  @click="OpenProfilePage('/employee-profile/' + data.item.id)"
                >
                  {{ data.item.last_name }}
                </p>
              </template>
              <template v-slot:cell(department)="data">
                {{data.item.department}}
              </template>
              <template v-slot:cell(country)="data">
                {{data.item.country}}
              </template>
              <template v-slot:cell(policy_0)="data">
                <PolicyColumns 
                  :index="0"
                  :healthAndSafetyData="data.item.employee_governance_training.health_and_safety_policy_tasks"
                />
              </template>
              <template v-slot:cell(policy_1)="data">
                <PolicyColumns 
                  :index="1"
                  :healthAndSafetyData="data.item.employee_governance_training.health_and_safety_policy_tasks"
                />
              </template>
              <template v-slot:cell(policy_2)="data">
                <PolicyColumns 
                  :index="2"
                  :healthAndSafetyData="data.item.employee_governance_training.health_and_safety_policy_tasks"
                />
              </template>
              <template v-slot:cell(policy_3)="data">
                <PolicyColumns 
                  :index="3"
                  :healthAndSafetyData="data.item.employee_governance_training.health_and_safety_policy_tasks"
                />
              </template>
              <template v-slot:cell(policy_4)="data">
                <PolicyColumns 
                  :index="4"
                  :healthAndSafetyData="data.item.employee_governance_training.health_and_safety_policy_tasks"
                />
              </template>
              <template v-slot:cell(policy_5)="data">
                <PolicyColumns 
                  :index="5"
                  :healthAndSafetyData="data.item.employee_governance_training.health_and_safety_policy_tasks"
                />
              </template>

              <!-- <template v-slot:cell()="data">
                <div v-if="setTasksColumns.length > 0">
                  <div
                    v-for="(tasksColumns, tasksColumnsIndex) in setTasksColumns"
                    :key="tasksColumnsIndex"
                  >
                    <div
                      v-for="(tasks, tasksIndex) in data.item.employee_governance_training.health_and_safety_policy_tasks"
                      :key="tasksIndex"
                    >
                      <div v-if="setTasksKeyConditon(data, tasks, tasksColumns)">
                        <span v-if="tasks.task_status == '0'">
                          <font-awesome-icon
                            size="lg"
                            icon="hourglass-half"
                          />
                        </span>
                        <span v-if="tasks.task_status == '1'">
                          <font-awesome-icon
                            size="lg"
                            icon="hourglass-half"
                          />
                        </span>
                        <b-badge
                          v-if="tasks.task_status == '2'"
                          variant="danger"
                        >On hold</b-badge>
                        <b-badge
                          v-if="tasks.task_status == '3'"
                          variant="dark"
                        >Review</b-badge>
                        <span
                          class="text-success"
                          v-if="tasks.task_status == '4'"
                        >
                          <font-awesome-icon
                            size="lg"
                            icon="check-circle"
                          />
                        </span>
                        <div class="text-center">
                          <span class="">
                            {{createdAtDate(tasks.created_at)}}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template> -->
            </b-table>
            </div>
            <template v-slot:footer>
              <b-row>
                <b-col cols="2">
                  <b-form-select
                    v-model="perPage"
                    id="perPageSelect"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                </b-col>
                <b-col cols="6">
                  <p class="text-center">
                    Displaying Result From
                    <b>{{ fromRows }}</b> to
                    <b>{{ toRows }}</b>
                  </p>
                </b-col>
                <b-col cols="4">
                  <b-pagination
                    class="float-right"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                    aria-controls="health-and-safety-policy-data-table"
                  ></b-pagination>
                </b-col>
              </b-row>
            </template>

            <b-modal
            title="Export with Date range"
            v-model="showSelectdDateForm"
            size="sm"
            no-close-on-backdrop
            no-close-on-esc
            hide-header-close
            >
          <div>
          
            <div
              ref="dialog"
              tabindex="-1"
              role="dialog"
              aria-modal="false"
              aria-labelledby="form-confirm-label"
              class="p-3"
            >
            <b-overlay :show="isFormsLoading">

               <b-form-group   label="Start Date:">
                  <b-form-datepicker
                    size="sm"
                    locale="en"
                    placeholder="Choose a Start Date"
                    :max="endDate"
                    v-model="startDate"
                  ></b-form-datepicker>
                  <p v-if="startDateIssue" style="color:#dc3545;font-size: 80%;">
                    Please select start date.
                  </p>
                </b-form-group>

                <b-form-group   label="End Date:">
                  <b-form-datepicker
                    size="sm"
                    locale="en"
                    placeholder="Choose a End Date"
                    :max="max"
                    :min="startDate"
                    v-model="endDate"
                  ></b-form-datepicker>
                    <p v-if="endDateIssue" style="color:#dc3545;font-size: 80%;">
                    Please select end date.
                  </p>
                </b-form-group>
    
                
            </b-overlay>
            </div>
          </div>
          <template v-slot:modal-footer>
            <b-button
              variant="outline-success"
              class="mr-3"
              @click="resetForms"
            >Cancel</b-button>
            <b-button
              variant="outline-danger"
              @click="exportDateRecord()"
            >Export</b-button>
          </template>
        </b-modal>




          </b-card>
        </b-overlay>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { HTTP } from "../../../utils/HTTP";
import moment from "moment";
import "moment/locale/es";
import { Helper } from "../../../helpers";
import { EventBus } from "@/event-bus.js";
import _ from "lodash";
import PolicyColumns from "./dynamicTrainingColumns.vue";
const now = new Date();
export default {
  name: "Policy",
  components: {
    PolicyColumns
  },
  data () {
    return {
      max: now,
      languagesOptions: [],
      selectedLanguage: null,
      showUpdateStatus: false,
      selectedEmployee: [],
      selectedEmployeeList: [],
      checkboxValue: null,
      showRenewForm: false,
      showSelectSendForm: false,
      processing: false,
      counter: 1,
      interval: null,
      employeeId: null,
      firstName: null,
      lastName: null,
      itemsBreadcrumb: [
        {
          text: "Dashboard",
          href: "dashboard",
        },
        {
          text: "Onboarding",
          href: "#",
          active: true,
        },
      ],
      isLoading: false,
      totalRows: 0,
      fromRows: 0,
      toRows: 0,
      filter: null,
      perPage: 10,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      governanceTableItems: [],
      setTasksColumns: [],
      staticFields: [],
      onboardingId: null,
      callFunction: true,
      employeesData: [],
      multipleEmployees: false,
      uniqEmployeeData: [],
      filterTable: false,
      departmentOptions: [],
      selectedDepartment: [],
      individualOptions: [],
      selectedIndividual: [],
      formsOptions: [],
      selectedForms: null,
      tablecolumns: [
        { field: "title", label: "Select All", sortable: false },
      ],
      selectedFormList: [],
      formsData: [],
      filterForms: null,
      formsName:[],
      isSendingForm: false,
      individualIssue: false,
      formIssue: false,
      tablerows: [],
      isFormsLoading: false,
      totalChildren: 0,
      showSelectdDateForm:false,
      endDate:now,
      startDate:"",
      startDateIssue:false,
      endDateIssue:false,      
    };
  },
  mounted () {
  },
  computed: {
    rows () {
      return this.totalRows;
    },
  },
  beforeDestroy () {
    this.clearInterval();
  },
  methods: {
    createdAtDate ( value ) {
      moment.locale( "en" );
      return moment( value ).format( "MMMM YYYY" );
    },
    submitSearch () {
      if ( this.filter ) {
        this.filterTable = true;
      }
    },
    onEmpltyFilter ( value ) {
      if ( value ) {
        return;
      } else {
        this.setFIlterClear();
      }
    },
    setFIlterClear () {
      this.filter = "";
      this.filterTable = false;
      this.reloadTable();
    },
    OpenProfilePage ( url ) {
      this.$router.push( url );
    },
    exportDatePolicyData(){
       this.showSelectdDateForm = true;
    },
    resetForms () {
       this.endDate= now;
      this.startDate="";
      this.startDateIssue=false;
      this.endDateIssue=false;
      this.showSelectdDateForm = false;
    },
    exportDateRecord(){
      if( this.startDate.length == 0 || this.endDate.length == 0){
        
        if(this.startDate.length == 0 ){
          this.startDateIssue = true;
        }else{
          this.startDateIssue = false;
        }

        if( this.endDate.length == 0){
            this.endDateIssue = true;
          }else{
             this.endDateIssue = false;
          }
       }else{

         this.startDateIssue = false;
         this.endDateIssue = false;
         // 
         this.exportDateRecordApiCall();
         
         
       }

    },
        async exportDateRecordApiCall (){

      let userId = localStorage.getItem( "userId" );
      this.isLoading = true;
      let formData = {
        start_date: this.startDate,
        end_date: this.endDate,
        user_id:userId,
      };

      let result = HTTP(
        "post",
        "api/v1/governance/training/employee/rs/download/health/and/safety/policy",
        formData,
        null,
        null,
        null,
        "blob",
      );
      
      return result
        .then( response => {
          let blob = new Blob( [response.data], {
            type: "application/octet-stream"
          } );
          this.resetForms();
          const url = window.URL.createObjectURL( blob );
          const link = document.createElement( "a" );
          link.href = url;
          link.setAttribute( "download", "HealthAndSafetyPolicyDate.xlsx" ); //or any other extension
          document.body.appendChild( link );
          link.click();
          this.isLoading = false;
        } )
        .catch( error => {
          this.resetForms();
          this.isLoading = false;
          return [error];
        } );

    },    
    exportPolicyData () {
      /*let formData = {
        upload_date_from_filter: '2022-06-01',
        upload_date_to_filter: '2022-06-11',
      };*/
      let userId = localStorage.getItem( "userId" );
      this.isLoading = true;
      let result = HTTP(
        "get",
        "api/v1/governance/training/employee/rs/download/health/and/safety/policy/" + userId,
        null,
        null,
        null,
        null,
        "blob"
      );
      return result
        .then( response => {
          let blob = new Blob( [response.data], {
            type: "application/octet-stream"
          } );
          const url = window.URL.createObjectURL( blob );
          const link = document.createElement( "a" );
          link.href = url;
          link.setAttribute( "download", "HealthAndSafetyPolicy.xlsx" ); //or any other extension
          document.body.appendChild( link );
          link.click();
          this.isLoading = false;
        } )
        .catch( error => {
          this.isLoading = false;
          return [error];
        } );
    },
    selectMultipleRows ( value, data ) {
      if ( value == 1 ) {
        this.firstName = data.item.first_name;
        this.lastName = data.item.last_name;
        this.employeesData.push( data.item.id );
      } else {
        let employeeIndex = this.employeesData.findIndex(
          ( x ) => x == data.item.id
        );
        this.employeesData.splice( employeeIndex, 1 );
      }
    },
    selectAllRows ( value ) {
      if ( value == 1 ) {
        this.governanceTableItems.map( ( items, index ) => {
          this.selectedEmployeeList[index] = 1;
          this.employeesData[index] = items.id
        } )
      } else {
        this.selectedEmployee = [];
        this.selectedEmployeeList = [];
        this.employeesData = [];
        this.uniqEmployeeData = [];
      }
    },
    onSelectRow ( data ) {
      if ( data[0].id ) {
        this.$router.push( "/employee-profile/" + data[0].id );
      }
    },
    clearInterval () {
      if ( this.interval ) {
        clearInterval( this.interval );
        this.interval = null;
      }
    },
    reloadTable () {
      this.$root.$emit( "bv::refresh::table", "health-and-safety-policy-data-table" );
    },
    setTasksKeyConditon ( data, tasks, tasksColumns ) {
      let tasksKey = tasks.task_title.toLowerCase().replace( /\s/g, "_" )+tasks.id;
      if ( data.field.key == tasksKey ) {
        if ( tasksKey == tasksColumns.key ) {
          if ( data.field.key == tasksColumns.key ) {
            return true;
          }
        }
      } else {
        return false;
      }
    },
    async setGovernanceTableData () {
      this.governanceTableItems = [];
      this.staticFields = [];
      this.setTasksColumns = [];
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + ( this.sortDesc == true ? "desc" : "asc" ),
        per_page: this.perPage,
        page: this.currentPage,
      };
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem( "accessToken" );
      try {
        const response = await HTTP(
          "post",
          "api/v1/governance/training/health/and/safety/data/policy/6",
          formData,
          {
            Authorization: token,
          }
        );
        this.setTasksHeadings( response );
        this.governanceTableItems = response.data.data;
        this.filterTable = false;
        this.totalRows = response.data.total;
        this.fromRows = response.data.from;
        this.toRows = response.data.to;
        return response.data.data;
      } catch ( err ) {
        this.isLoading = false;
        return [err];
      }
    },
    setTasksHeadings ( response ) {
      // this.staticFields = 
      this.staticFields = [
        { key: "checkbox", label: "", sortable: false },
        { key: "first_name", label: "First Name", sortable: true },
        { key: "last_name", label: "Last Name", sortable: true },
        { key: "department", label: "Division Unit", sortable: true },
        { key: "country", label: "Country", sortable: true },
        { key: "policy_0", label: "Policy", sortable: false},
        { key: "policy_1", label: "Policy", sortable: false},
        { key: "policy_2", label: "Policy", sortable: false},
        { key: "policy_3", label: "Policy", sortable: false},
        { key: "policy_4", label: "Policy", sortable: false},
        { key: "policy_5", label: "Policy", sortable: false},
      ];
      this.setTasksColumns = [];
      // response.data.data.map( ( tableData, index ) => {
      //   tableData.employee_governance_training.health_and_safety_policy_tasks.map( ( tasksItems ) => {
      //     let fieldKey = tasksItems.task_title
      //       .toLowerCase()
      //       .replace( /\s/g, "_" ) + tasksItems.id;
      //     // if ( index == 0 ) {
      //       let index = -1;
      //       this.staticFields.map( ( item, indexValue ) => {
      //         if(item.key == fieldKey) {
      //           index = indexValue;
      //         }
      //       } )
      //       if(index == -1) {
      //           this.staticFields.push( {
      //           key: fieldKey,
      //           // label: tasksItems.task_title,
      //           label: 'Policy',
      //           sortable: false,
      //         } );
      //         this.setTasksColumns.push( {
      //           key: fieldKey,
      //           // text: tasksItems.task_title,
      //           text: 'Policy',
      //           form_type: tasksItems.form_type,
      //         } );
      //       }            
      //   } );
      // } );
      this.isLoading = false;
      // if ( this.callFunction ) {
      //   this.reloadTable();
      // }
      // this.callFunction = false;
    },
  },
};
</script>

<style scoped>
@import "../../../assets/styles/theme1/tabs.css";
@import "../../../assets/styles/theme1/timeline.css";

.card-body {
  padding: 0px;
}

.fixed-bottom {
  right: auto !important;
  left: auto !important;
  width: 100%;
}
</style>

<style>
body {
  font-family: Heebo, sans-serif;
  font-size: 0.95rem;
  font-weight: 400;
  line-height: 1.5;
  color: #3b3e66;
}

.card-header {
  /* #background-color:#dcdef1; */
  /* padding: 0.4rem 0.4rem; */

  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #fff;
  border-bottom: 0 solid rgba(122, 123, 151, 0.3);
}

/* .table .thead-light th {
    color: #3b3e66;
    background-color: rgba(239,239,247,.7);
    border-color: #dcdef1;
} */
.table {
  font-size: 0.83125rem;
  color: #3b3e66;
}

.table.b-table > thead > tr .table-b-table-default {
  background-color: rgba(239, 239, 247, 0.7);
  color: #3b3e66;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: #f9fafe;
  color: #3b3e66;
}

.table thead th {
  text-transform: uppercase;
  font-size: 0.83125rem;
  border-color: #dcdef1;
  vertical-align: bottom;
  border-bottom: 2px solid #dcdef1;
}

.form-group {
  margin-bottom: 0rem;
}

.group-prepend > .btn,
.input-group-sm > .input-group-append > .btn {
  font-size: 0.75rem;
}

.progress {
  height: 0.5rem;
}

.btn-sm {
  font-size: 0.75rem;
}

</style>
